export const clusterLayerId = 'clusters';
export const clusterCountLayerId = 'cluster-count';
export const unclusteredPointLayerId = 'unclustered-point';
